var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "76.26 34.84 48.02 34.84 48.02 196.09 168.77 196.09 168.77 34.84 140.52 34.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.27,
    y: 66.06,
    width: 26.5,
    height: 26.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.27,
    y1: 118.35,
    x2: 148.77,
    y2: 118.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.27,
    y1: 131.85,
    x2: 148.77,
    y2: 131.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 114.77,
    y1: 73.31,
    x2: 148.77,
    y2: 73.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 114.77,
    y1: 86.56,
    x2: 148.77,
    y2: 86.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.89,24.87a9.56,9.56,0,0,1,19,0h14.78a7.68,7.68,0,0,1,7.85,7.5v4.88a7.69,7.69,0,0,1-7.85,7.5H84.12a7.68,7.68,0,0,1-7.85-7.5V32.37a7.67,7.67,0,0,1,7.85-7.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.27,
    y1: 155.35,
    x2: 148.77,
    y2: 155.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.27,
    y1: 168.85,
    x2: 148.77,
    y2: 168.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/CLIPBOARD.88978a4789eab1722c466e4bd1810003.svg";
export { ForwardRef as ReactComponent };